function chooseDate(created, photoChange) {
    const createdString = created.toString()
    const photoChangeString = photoChange.toString()
    const photoChangee = new Date(photoChangeString)
    const createdAt = new Date(createdString)
    return createdAt < photoChangee ? createdString : photoChangeString
}

export default chooseDate;